import {useState} from 'react'
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import {KTIcon} from '../../../_metronic/helpers'
import {formatMonetaryToBr} from '../../../utils/formatMonetaryToBr'
import {manualPaymentInvoice} from '../core/_request'

type Props = {
  franchiseId: number
  invoiceId: number
  referenceCode: string
  totalAmount: number
  onClose: () => void
  onSuccess: () => void
}

const ManualPaymentModal = ({
  franchiseId,
  invoiceId,
  referenceCode,
  totalAmount,
  onClose,
  onSuccess,
}: Props) => {
  const today = dayjs().format('YYYY-MM-DD')
  const [paidAt, setPaidAt] = useState(today)
  const [observation, setObservation] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async () => {
    if (!paidAt) {
      await Swal.fire({icon: 'warning', title: 'Oops...', text: 'Informe a data do pagamento.'})
      return
    }

    try {
      setIsSubmitting(true)
      await manualPaymentInvoice(franchiseId, invoiceId, {
        paid_at: paidAt,
        observation: observation || undefined,
      })
      await Swal.fire({
        icon: 'success',
        title: 'Baixa realizada',
        text: `A fatura ${referenceCode} foi marcada como paga.`,
        timer: 2000,
        showConfirmButton: false,
      })
      onSuccess()
    } catch (error: any) {
      await Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: error?.response?.data?.message,
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
        <div className='modal-dialog modal-dialog-centered mw-500px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder m-0'>Baixa manual de fatura</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-danger'
                onClick={onClose}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>

            <div className='modal-body p-9'>
              <div className='mb-7 text-gray-700'>
                Fatura <span className='fw-bolder'>{referenceCode}</span> no valor de{' '}
                <span className='fw-bolder'>{formatMonetaryToBr(totalAmount)}</span>. Use esta
                opção para pagamentos recebidos fora da cobrança automática.
              </div>

              <div className='mb-7'>
                <label className='required fw-bold fs-6 mb-2'>Data do pagamento</label>
                <input
                  type='date'
                  className='form-control form-control-solid'
                  value={paidAt}
                  max={today}
                  onChange={(e) => setPaidAt(e.target.value)}
                  disabled={isSubmitting}
                />
              </div>

              <div className='mb-7'>
                <label className='fw-bold fs-6 mb-2'>Observação</label>
                <textarea
                  className='form-control form-control-solid'
                  rows={3}
                  maxLength={255}
                  value={observation}
                  onChange={(e) => setObservation(e.target.value)}
                  disabled={isSubmitting}
                />
              </div>

              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  className='btn btn-light me-3'
                  onClick={onClose}
                  disabled={isSubmitting}
                >
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span className='indicator-progress d-block'>
                      Aguarde...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    'Confirmar baixa'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {ManualPaymentModal}
